function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "23",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.071 2.714L26.838 19.94A2 2 0 0125.142 23H3.608a2 2 0 01-1.696-3.06L12.68 2.714a2 2 0 013.392 0z",
  fill: "#FFD391"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.375 17a1 1 0 011 1 1.001 1.001 0 11-2 .006c0-.558.448-1.006 1-1.006zm0-10a1 1 0 011 1v6.295a1 1 0 01-2 0V8a1 1 0 011-1z",
  fill: "#FFF"
}))));